<!-- Trigger button (portal service creates panel content at body) -->
<button
  class="help-trigger"
  type="button"
  (click)="openPanel()"
  [attr.aria-label]="'Help: ' + (helpKey || 'information')"
>
  <fa-icon [icon]="faInfoCircle"></fa-icon>
</button>
